import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
  name: 'default',
} )
export class DefaultValuePipe implements PipeTransform {
  transform( value: any, defaultValue: any ): any {
    return ( typeof value === 'undefined' || value === null ) ? defaultValue : value;
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/pipes/default-value.pipe.ts